import {
  Box,
  Button,
  Card,
  Divider,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { ChevronUp } from "src/icons/chevron-up";
import { useDispatch } from "src/store";
import { ChevronDown } from "../../../icons/chevron-down";
import { ExclamationHollowCircle } from "../../../icons/exclamation-hollow-circle";
import { XHollow } from "../../../icons/x-hollow-icon";
import {
  getProjects,
  projects,
  projectsLoadingState,
} from "../../../slices/projects";

export const SelectProjectDropdown = ({
  setCurrentProject,
  count,
  tab,
  isArticle,
}) => {
  const router = useRouter();
  const [selectedproject, setSelectedProject] = useState("All");
  const [open, setOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState("#5048E5");
  const [allProjects, setAllProjects] = useState([]);

  const dispatch = useDispatch();
  const Projects = useSelector(projects);
  const [selectText, setSelectText] = useState(" Filter by project");
  const [selectColor, setSelectColor] = useState("#5048E5");
  const [setProject, setProjectState] = useState([]);
  const [totalBriefs, setTotalBriefs] = useState(0);

  const loaders = useSelector(projectsLoadingState);

  useEffect(() => {
    dispatch(getProjects());

    setSelectColor("#5048E5");
    setSelectText("Filter by project");
    if (selectedproject == "All") {
      setTotalBriefs(count);
    }
  }, []);

  useEffect(() => {
    if (selectedproject == "All") {
      setTotalBriefs(count);
    }
  }, [count]);

  useEffect(() => {
    setSelectText("Filter by project");
    setSelectedProject("All");
    setCurrentProject("All");
    setSelectColor("#5048E5");

    if (selectedproject == "All") {
      setTotalBriefs(count);
    }
  }, [tab]);

  useEffect(() => {
    setAllProjects(Projects);
    setProjectState(Projects);
  }, [Projects]);

  const filterProjects = (value) => {
    const project = setProject;
    const filteredProjects = project.filter((project) => {
      return project.projectName.toLowerCase().includes(value.toLowerCase());
    });
    setAllProjects(filteredProjects);
  };

  const ref: any = useRef();
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!ref?.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <Box display="" justifyContent="right" sx={{ mt: 1.5 }}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ mr: 1, cursor: "pointer" }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <Typography
          color={selectColor}
          sx={{
            fontSize: "16",
            fontWeight: "600",
            fontFamily: "Inter",
            lineHeight: "19px",
          }}
        >
          {selectText}{" "}
        </Typography>
        {selectText !== "Filter by project" && (
          <XHollow
            sx={{
              ml: 1,
              mt: 0.5,
              // color: "grey",
            }}
            onClick={() => {
              setSelectText("Filter by project");
              setSelectedProject("All");
              setCurrentProject("All");
              setSelectColor("#5048E5");

              // setOpen(false);
            }}
          />
        )}
        {!open ? (
          <ChevronDown sx={{ ml: 1, color: selectColor }} />
        ) : (
          <ChevronUp sx={{ ml: 1, color: selectColor }} />
        )}
      </Box>

      {open && (
        <Box
          sx={{
            position: "relative",
            mt: 1,
            // ml: 3,
          }}
        >
          <Card
            sx={{
              zIndex: 100,
              position: "absolute",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
              borderRadius: "4px",
              border: "1px solid #eee",
              padding: "0rem 0.8rem ",
              width: "18rem",
            }}
            ref={ref}
          >
            <Box sx={{}}>
              <TextField
                fullWidth
                id="standard-basic"
                label="Search"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                onChange={(e) => {
                  filterProjects(e.target.value);
                }}
              />
              <Divider
                sx={{
                  mb: 1,
                  ml: -1,
                  mr: -1,
                  backgroundColor: "blue !important",
                  color: "blue !important",
                }}
              />
            </Box>
            {allProjects && (
              <Box
                sx={{
                  maxHeight: "15rem",
                  overflowY: "auto",
                }}
              >
                <Box
                  display="flex"
                  sx={{
                    p: 1,
                  }}
                >
                  <Typography
                    color={selectedproject === "All" ? "#5048E5" : "#121828"}
                    fontWeight={selectedproject === "All" ? "600" : "500"}
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      textAlign: "left",

                      cursor: "pointer",
                    }}
                    onClick={() => {
                      [
                        setSelectedProject("All"),
                        setCurrentProject("All"),
                        setSelectText("Filter by project"),
                        setSelectColor("#5048E5"),
                      ];
                    }}
                  >
                    {isArticle ? "All Articles" : "All Briefs"}
                  </Typography>
                  <Typography
                    color={selectedproject === "All" ? "#5048E5" : "#121828"}
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      float: "right",
                      ml: "auto",

                      fontWeight: "500",
                    }}
                  >
                    {totalBriefs}
                  </Typography>
                </Box>

                {allProjects.map((project) => (
                  <Box
                    key={project.projectId}
                    display="flex"
                    sx={{
                      p: 1,
                    }}
                  >
                    <Typography
                      color={
                        selectedproject === project.projectId
                          ? "#5048E5"
                          : "#121828"
                      }
                      fontWeight={
                        selectedproject === project.projectId ? "600" : "500"
                      }
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        textAlign: "left",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        [
                          setSelectedProject(project.projectId),
                          setCurrentProject(project.projectId),
                          setSelectText(project.projectName),
                          setSelectColor("#121828"),
                        ];
                      }}
                    >
                      {project.projectName}
                    </Typography>
                    <Tooltip
                      title={project.projectDomain}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "#000",
                            "& .MuiTooltip-arrow": {
                              color: "common.black",
                              borderRadius: "4px",
                            },
                          },
                        },
                      }}
                      placement="top"
                    >
                      <ExclamationHollowCircle
                        sx={{
                          ml: "5px",
                          mt: "5px",
                          cursor: "pointer",
                          fontSize: "1.2rem",
                        }}
                      />
                    </Tooltip>
                    <Typography
                      color={
                        selectedproject === project.projectId
                          ? "#5048E5"
                          : "#121828"
                      }
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        float: "right",
                        ml: "auto",

                        fontWeight: "500",
                      }}
                    >
                      {isArticle
                        ? project.optimizedArticleCount
                        : project.briefCount}
                    </Typography>
                  </Box>
                ))}
                <Typography
                  color={
                    selectedproject === "Unassigned" ? "#5048E5" : "#121828"
                  }
                  fontWeight={selectedproject === "Unassigned" ? "600" : "500"}
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Inter",

                    textAlign: "left",
                    p: 1,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    [
                      setSelectedProject("Unassigned"),
                      setCurrentProject("Unassigned"),
                      setSelectText("Unassigned"),
                      setSelectColor("#121828"),
                    ];
                  }}
                >
                  Unassigned
                </Typography>
              </Box>
            )}
            {/* Create Project Button */}

            <Button
              variant="outlined"
              onClick={() => {
                router.push({
                  pathname: "/projects/settings/",
                  query: {
                    url: "new",
                  },
                });
              }}
              sx={{
                fontSize: "11px",
                fontWeight: "600",
                fontFamily: "Inter",
                color: "#5048E5",
                float: "left",
                marginTop: "0.5rem",
                marginBottom: "1.5rem",
                borderRadius: "4px",
                padding: "8px",
              }}
            >
              <span style={{ marginRight: "0.5rem" }}>+</span>
              Add New Project
            </Button>
          </Card>
        </Box>
      )}
    </Box>
  );
};
